export const ERROR_BOTTOM_SHEETS = {
  duplication_in_data: {
    namespace: 'registration' as const,
    type: 'DuplicateAccountsBottomSheet' as const,
  },
  'max-duplicates-reached': {
    namespace: 'registration' as const,
    type: 'MaxDuplicatesReachedBottomSheet' as const,
  },
} as const;

export const ALLOWED_NAVIGATION_URLS = [
  '/terms',
  '/contact',
  '/status',
  '/level-up',
  '/privacy',
  '/about',
  '/all',
];

export const MARKETING_OPT_OUT_MODAL_SHOWN_STORAGE_KEY =
  'marketing_opt_out_modal_shown';
